const MAP_BASE_URL = "https://maps.googleapis.com/maps/api/distancematrix/json";
export default MAP_BASE_URL;
